import { jsx } from 'react/jsx-runtime';
import classnames from '../../node_modules/classnames/index.js';
import { forwardRef } from 'react';
import modules_e6a5a2d0 from './Typography.module.scss.js';

const variantMapping = {
    default: "span",
    "display-l": "h1",
    "display-m": "h1",
    "display-s": "h2",
    "display-xs": "h2",
    "heading-xl": "h1",
    "heading-l": "h2",
    "heading-m": "h2",
    "heading-s": "h3",
    "heading-xs": "h4",
    "heading-xxs": "h4",
    "heading-xxxs": "h4",
    "body-xl": "p",
    "body-l": "p",
    "body-m": "p",
    "body-s": "p",
    "body-xs": "p",
    inherit: "span",
    body: "p",
};
const Typography = forwardRef(({ as, className, variant = "default", gutterBottom = false, disableResponsiveSizing = false, fontStyle, appearance = "default", wrap, ...others }, ref) => {
    const Component = as || variantMapping[variant] || "span";
    // Use the weight prop if passed in from a Body variant -
    const weight = "weight" in others ? others.weight : null;
    return (jsx(Component, { className: classnames(modules_e6a5a2d0.typography, modules_e6a5a2d0[`appearance-${appearance}`], modules_e6a5a2d0.prettyStyle, modules_e6a5a2d0[wrap || ""], {
            [modules_e6a5a2d0[variant]]: variant !== "inherit",
            [modules_e6a5a2d0.disableResponsiveSizing]: disableResponsiveSizing,
            [modules_e6a5a2d0.gutterBottom]: gutterBottom,
            [modules_e6a5a2d0[`weight-${weight}`]]: weight,
            [modules_e6a5a2d0[`fontstyle-${fontStyle}`]]: fontStyle,
        }, className), ref: ref, ...(appearance === "disabled" ? { "aria-disabled": true } : {}), ...others }));
});

export { Typography };
//# sourceMappingURL=Typography.js.map
